import { useState, useEffect } from "react";
import api from "../../api/axois";

const stars = (n) => "★".repeat(n) + "☆".repeat(5 - n);

export default function ReviewsSection({ roomTypeId }) {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!roomTypeId) return;
    setLoading(true);
    api
      .get(`/room-types/${roomTypeId}/reviews`)
      .then((res) => setReviews(res.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [roomTypeId]);

  if (loading) return <p style={{ color: "#718096" }}>Loading reviews…</p>;
  if (!reviews.length) return <p style={{ color: "#718096" }}>No reviews yet for this room type.</p>;

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 16, marginTop: 8 }}>
      {reviews.map((r) => {
        const initials = (r.reviewer_name || "Guest")
          .split(" ")
          .slice(0, 2)
          .map((w) => w[0]?.toUpperCase())
          .join("");
        return (
          <div
            key={r.id}
            style={{
              background: "#fff",
              border: "1px solid #e2e8f0",
              borderRadius: 10,
              padding: "16px 20px",
              minWidth: 260,
              maxWidth: 340,
              flex: "1 1 260px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
              <div
                style={{
                  width: 38,
                  height: 38,
                  borderRadius: "50%",
                  background: "#233d81",
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: 700,
                  fontSize: 14,
                  flexShrink: 0,
                }}
              >
                {initials}
              </div>
              <div>
                <div style={{ fontWeight: 600, fontSize: 14 }}>{r.reviewer_name || "Guest"}</div>
                <div style={{ color: "#d4af37", fontSize: 15, letterSpacing: 1 }}>{stars(r.rating)}</div>
              </div>
            </div>
            {r.comment && (
              <p style={{ margin: 0, fontSize: 13, color: "#4a5568", lineHeight: 1.5 }}>
                &ldquo;{r.comment}&rdquo;
              </p>
            )}
            <p style={{ margin: "8px 0 0", fontSize: 11, color: "#aaa" }}>
              {new Date(r.created_at).toLocaleDateString("en-GB")}
            </p>
          </div>
        );
      })}
    </div>
  );
}
